import React from "react";
import { Container, Box, Stack, Typography } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";

import Button from "../../../components/Button";
import SeeDemoComp from "../../../components/SeeDemo";
import SignUpCommonDialog from "../../../components/singUpForm/SignUpCommonDialog";
import CommonDialog from "../../../components/dialog/CommonDialog";
import ThankYouDemoDialog from "../../../components/SeeDemo/ThankYouDemoDialog";
import { clickEvent } from "../../../utils/helpers/createEvent";

const HeroBanner = () => {
  const [open, setOpen] = React.useState(false);
  const [thankYou, setThankYou] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);

    const eventData = {
      category: "See Demo Form",
      action: `Clicked on See Demo`,
      debug_mode: true,
    }

    clickEvent(eventData);
  };

  const handleClose = () => {
    setOpen(false);
    
    const eventData = {
      category: "See Demo Form",
      action: `Clicked Cancel on See a Demo Form.`,
      debug_mode: true,
    }
    clickEvent(eventData);
  };

  const handleGetStarted = () => {
    const eventData = {
      category: "Get Started",
      action: `Clicked on Get Started.`,
      debug_mode: true,      
    }
    
    clickEvent(eventData);
  }

  return (
    <>
      <Box component="section" className="hero-banner">
        <Container>
          <div className="hero-banner-content">
            <Typography variant="h1">
              Project management, simplified for teams of any size.
            </Typography>
            <Typography variant="body1">
              All the powerful features of top project management tools – at one
              fixed price, with no per-user fees.{" "}
              <span style={{ fontWeight: "500" }}>
                Try TaskBoard free for 30 days, no credit card required.
              </span>
            </Typography>

            <Stack direction="row" spacing={2} justifyContent="center">
              <SignUpCommonDialog
                title={"Get Started"}
                className={"custom-btn"}
                callback={handleGetStarted}
              >
                <ArrowOutwardIcon />
              </SignUpCommonDialog>
              <Button
                buttonText={"See a Demo"}
                className={"custom-btn-outline"}
                handleClick={handleClickOpen}
              />
            </Stack>
            <p className="no-creditcard-text">No credit card required.</p>
          </div>
        </Container>
      </Box>
      {thankYou && (
        <CommonDialog
          open={thankYou}
          handleClose={() => setThankYou(false)}
          title={"Thankyou"}
          className="thankyou-popup"
        >
          <ThankYouDemoDialog />
        </CommonDialog>
      )}

      {open && (
        <SeeDemoComp
          open={open}
          handleClose={handleClose}
          setThankYou={setThankYou}
        />
      )}
    </>
  );
};
export default HeroBanner;
